/**
 * DATA SOURCE CONFIG
 * ──────────────────────────────────────────────────────────────────────────
 * Controls where each data type is loaded from. Change ONE value here and
 * every part of the app (Redux actions + direct calls) will switch sources.
 *
 *   'local'   → use the static data in Public/*-data.js (instant, no API)
 *   'backend' → fetch from the API and store in Redux
 *
 * WHITE-LABEL TEMPLATE MODE: everything is 'local' so the whole site renders
 * from the placeholder data in Public/*-data.js with no backend running. Flip a
 * line to 'backend' to wire that section up to the real API / S3, section by
 * section, as each client's content gets seeded.
 */

const DataSourceConfig = {
    home:           'local',    // 'local' | 'backend'
    categories:     'backend',  // 'local' | 'backend' — seeded to S3 (7 cats, Retractable Screens active)
    services:       'backend',  // 'local' | 'backend' — seeded to S3 (3 retractable services)
    infoCards:      'backend',  // 'local' | 'backend' — seeded to S3 (7 feature icons)
    blogs:          'backend',  // 'local' | 'backend' — seeded to S3 (3 retractable-screen guides)
    reviews:        'local',    // 'local' | 'backend' — placeholder reviews until Google reviews are seeded
    events:         'local',    // 'local' | 'backend'
    privacy:        'local',    // 'local' | 'backend'
    terms:          'local',    // 'local' | 'backend'
    bannerMessages: 'backend',  // no local mock yet — keep backend
    links:          'backend',  // no local mock yet — keep backend (nav/system links)
    products:       'backend',  // no local mock yet — keep backend
};

export default DataSourceConfig;
